import React, { useContext, useEffect, useMemo, useState } from "react";
import styles from "@/page-components/snapshot/snapshots.module.css";
import clsx from "clsx";
import { AppContext } from "@/App.context";
import { Dropdown, Offcanvas } from "react-bootstrap";
import menuicon from "@/assets/img/menu.svg";
import Pagination from "@/components/pagination/pagination.component";
import editIcon from "@/assets/img/editoracces.svg";
import binIcon from "@/assets/img/bin.svg";
import styled from "@/page-components/taggings/tagging.module.css";
import TableErrorState from "@/components/States/TableErrorState";
import ScenariosErrorState from "@/components/States/scenariosErrorState";
import download from "@/assets/img/download.svg";

import {
  API_LOADING_ERROR,
  API_NO_DATA_FOUND_ERROR,
  API_NOT_FOUND_ERROR,
} from "@/lib/errors/error-constants";
import { useNavigate, useSearchParams } from "react-router-dom";
import { TaggingContext } from "../tagging-context-file";
import { useTaggingTableData } from "@/services/taggings/get-tagging-table.repo";

function TaggingTableSection({ service, deleteSuccess }) {
  const context = useContext(AppContext);
  const contexts = useContext(TaggingContext);
  const navigate = useNavigate();
  const name = String(context?.user?.name).toLowerCase();
  const [hoveredRowIndex, setHoveredRowIndex] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const page = searchParams.get("page");
  const itemsPerPage = searchParams.get("itemsPerPage");

  const parsedPage = !Number.isNaN(parseInt(page)) ? parseInt(page) : 1;
  const parsedItemsPerPage = !Number.isNaN(parseInt(itemsPerPage))
    ? parseInt(itemsPerPage)
    : 10;

  const query = useMemo(
    () => ({
      service: service,
      page: parsedPage || 1,
      recordsPerPage: parsedItemsPerPage || 10,
    }),
    [parsedItemsPerPage, parsedPage]
  );
  const { data, isLoading, error, refetch } = useTaggingTableData(query);

  useEffect(() => {
    contexts?.setRefetchTable(() => refetch);
  }, [refetch]);

  const items = [
    {
      eventKey: "Download as CSV",
      icon: download,
      label: "Download as CSV",
    },
  ];

  const handleMouseEnter = (index) => {
    setHoveredRowIndex(index);
  };

  const handleMouseLeave = () => {
    setHoveredRowIndex(null);
  };

  const HandleEditDAta = (data) => {
    contexts?.setEditdata(data[0]);
  };

  useEffect(() => {
    refetch();
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set("page", "1");
    navigate(`?${searchParams.toString()}`);
  }, [deleteSuccess]);

  return (
    <>
      {isLoading && <TableErrorState />}
      {error && (
        <ScenariosErrorState
          error={error.message}
          messageConfig={{
            [API_NO_DATA_FOUND_ERROR]: {
              message: "No Data Available",
              additionalMessage:
                "We couldn’t retrieve data at this moment. This might be due to an absence of data or a temporary issue. Please try again later.",
            },
            [API_LOADING_ERROR]: {
              message: "Oops!",
              additionalMessage:
                "We encountered a problem loading your data. Please ensure a stable internet connection and try again. If the issue persists, contact support.",
            },
            [API_NOT_FOUND_ERROR]: {
              message: "404 Error",
              additionalMessage:
                "We couldn’t find the data you’re looking for. This might be due to a temporary issue or incorrect resource. Please check back later or contact support if the problem persists.",
            },
          }}
        />
      )}
      {!isLoading && !error && data && (
        <>
          <div className={styles.table_container} style={{ width: "100%" }}>
            <table
              className="table table-hover"
              id="customers"
              style={{ margin: "0px", width: "100%" }}
            >
              <thead>
                <tr
                  style={{
                    background: "#F6F6F6",
                    borderBottom: "1px solid #F6F6F6",
                  }}
                >
                  <th className={styles.snap_th_class}>Virtual Tag Name</th>
                  <th className={styles.snap_th_class}>No. Tag Keys</th>
                  <th className={styles.snap_th_class}>Tag Keys Value</th>
                  <th className={styles.snap_th_class}>Description</th>
                  <th className={styles.snap_th_class}>Created on</th>
                  <th className={styles.snap_th_class}>
                    {/* <DropdowmComponent
                      menuIcon={menuicon}
                      items={items}
                      onItemClick={handleDownloadClicked}
                    /> */}
                  </th>
                </tr>
              </thead>

              <tbody style={{ borderRight: "white", borderLeft: "white" }}>
                {(data?.data?.tagsList || []).map((item, index) => (
                  <tr
                    className={clsx(
                      {
                        [styles.trhovered]: index === hoveredRowIndex,
                      },
                      styles.for_copy_hover
                    )}
                    key={index}
                    onMouseEnter={() => handleMouseEnter(index)}
                    onMouseLeave={handleMouseLeave}
                    style={{ lineHeight: "17px" }}
                  >
                    <td title={data?.name}>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "1px",
                        }}
                      >
                        <span
                          className={clsx(
                            styled.snap_table_data__Class,
                            "elipese"
                          )}
                          style={{ color: "#056EE5", cursor: "pointer" }}
                        >
                          {item?.name || "--"}
                        </span>

                        <div
                          style={{
                            fontSize: "11px",
                            fontWeight: "400",
                            fontStyle: "italic",
                            color: "#495057",
                          }}
                        >
                          Created By{" "}
                          {String(item?.username).toLowerCase() === name
                            ? "You"
                            : item?.username}
                        </div>
                      </div>
                    </td>
                    <td
                      className={clsx(styled.snap_table_data__Class, "elipese")}
                      title={item?.anomalies}
                      style={{ paddingTop: "16px" }}
                    >
                      {item?.tagcount || "--"}
                    </td>
                    <td>
                      <div
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "6px",
                        }}
                      >
                        {item.tagKeys.slice(0, 5).map((tag, idx) => (
                          <span key={idx} className={styled.tags_key}>
                            {tag}
                          </span>
                        ))}
                        {item.tagKeys.length > 5 && (
                          <span
                            className={styled.tags_key}
                            style={{
                              background: "#E6EEFA",
                            }}
                          >
                            +{item.tagKeys.length - 5} more
                          </span>
                        )}
                      </div>
                    </td>
                    <td
                      className={styled.table_des}
                      style={{ paddingTop: "16px" }}
                      title={item?.description}
                    >
                      {item?.description || "--"}
                    </td>
                    {/* <td
                      className={styled.snap_table_data__Class}
                      style={{ paddingTop: "16px" }}
                    >
                      {item?.createdate
                        ? new Date(item.createdate).toISOString().split("T")[0]
                        : "--"}
                    </td> */}
                    <td
                      className={styled.snap_table_data__Class}
                      style={{ paddingTop: "16px" }}
                    >
                      {item?.createdate
                        ? (() => {
                            const date = new Date(item.createdate);
                            const day = String(date.getDate()).padStart(2, "0");
                            const month = String(date.getMonth() + 1).padStart(
                              2,
                              "0"
                            );
                            const year = String(date.getFullYear()).slice(-2);
                            return `${day}/${month}/${year}`;
                          })()
                        : "--"}
                    </td>

                    <td
                      className={clsx(
                        styled.snap_table_data__Class,
                        styles.snapshot_col_weight
                      )}
                      style={{ paddingTop: "16px" }}
                    >
                      <Dropdown style={{ marginTop: "-6px" }}>
                        <Dropdown.Toggle
                          className={styles.dropdown_toggle}
                          variant="link"
                          id={`dropdown-basic-${index}`}
                          style={{
                            background: "none",
                            border: "none",
                            padding: 0,
                          }}
                        >
                          {(context?.selectedItems || []).length < 1 && (
                            <img
                              src={menuicon}
                              alt=""
                              style={{ padding: "4px 6px" }}
                            ></img>
                          )}
                        </Dropdown.Toggle>

                        <Dropdown.Menu
                          id={styles.dropdown_menu_item}
                          style={{
                            border: "none",
                            boxShadow: "0 19px 14px rgba(0, 0, 0, 0.1)",
                          }}
                          className={styled.inset}
                        >
                          <Dropdown.Item
                            id={styles.dropdown_item}
                            onClick={() => {
                              contexts?.setIsLayoverOpen(true);
                              HandleEditDAta([item]);
                            }}
                          >
                            <span className={styles.dropdown_names_css}>
                              <img
                                src={editIcon}
                                alt=""
                                className={styled.dropdown_icon}
                              />
                              Edit
                            </span>
                          </Dropdown.Item>

                          <Dropdown.Divider />

                          <Dropdown.Item
                            id={styles.dropdown_item}
                            onClick={() => {
                              contexts?.setConfirmationmodal(true);
                              contexts?.setDeleteData(item?.tagId);
                              // HandleDeleted(data?.anomaly_id);
                            }}
                          >
                            <span
                              className={styles.dropdown_names_css}
                              style={{ color: "#D01A1A" }}
                            >
                              <img
                                src={binIcon}
                                alt=""
                                className={styled.dropdown_icon}
                              />
                              Delete Virtual Tag
                            </span>
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <Pagination totalItems={data?.data?.totalCount || 0} />
        </>
      )}
    </>
  );
}

export default TaggingTableSection;
